export const messages = {
  en: {
    shareReading: {
      search: {
        title: 'Search Conditions',
        selectMeter: 'Please select shared meter',
        startTime: 'Please select start time',
        endTime: 'Please select end time'
      },
      list: {
        title: 'Shared Meter Reading',
        addReading: 'Add Reading'
      },
      table: {
        id: 'ID',
        name: 'Name',
        preDegrees: 'Previous Degrees',
        curDegrees: 'Current Degrees',
        degrees: 'Degrees',
        preReadingTime: 'Previous Reading Time',
        curReadingTime: 'Current Reading Time',
        reader: 'Reader',
        status: 'Status',
        remark: 'Remark',
        auditor: 'Auditor',
        auditOpinion: 'Audit Opinion',
        shareProgress: 'Share Progress',
        readingTime: 'Reading Time',
        shareFee: 'Share Fee',
        operation: 'Operation'
      },
      status: {
        waiting: 'Waiting',
        passed: 'Passed',
        rejected: 'Rejected',
        all: 'All'
      },
      add: {
        title: 'Add Shared Reading',
        meter: 'Shared Meter',
        selectMeter: 'Please select shared meter',
        preDegrees: 'Previous Degrees',
        inputPreDegrees: 'Please input previous degrees',
        curDegrees: 'Current Degrees',
        inputCurDegrees: 'Please input current degrees',
        preReadingTime: 'Previous Reading Time',
        selectPreTime: 'Please select previous reading time',
        curReadingTime: 'Current Reading Time',
        selectCurTime: 'Please select current reading time',
        remark: 'Remark',
        inputRemark: 'Please input remark (optional)'
      },
      audit: {
        title: 'Audit Shared Reading',
        status: 'Status',
        selectStatus: 'Please select status',
        remark: 'Remark',
        inputRemark: 'Please input remark'
      },
      delete: {
        title: 'Delete Confirmation',
        confirm: 'Are you sure to delete this shared reading?'
      },
      validate: {
        selectMeter: 'Please select shared meter',
        inputPreDegrees: 'Please input previous degrees',
        inputCurDegrees: 'Please input current degrees',
        selectPreTime: 'Please select previous reading time',
        selectCurTime: 'Please select current reading time',
        selectStatus: 'Please select audit status',
        number: 'Please input valid number'
      },
      message: {
        addSuccess: 'Add shared reading successfully',
        auditSuccess: 'Audit shared reading successfully',
        deleteSuccess: 'Delete shared reading successfully'
      },
      page: {
        subtitle: 'Record and audit shared-meter readings, then share the cost to related rooms',
        empty: 'No shared readings found',
        loadFailed: 'Shared readings failed to load, please retry'
      }
    }
  },
  zh: {
    shareReading: {
      search: {
        title: '查询条件',
        selectMeter: '请选择公摊表',
        startTime: '请选择开始时间',
        endTime: '请选择结束时间'
      },
      list: {
        title: '公摊抄表',
        addReading: '抄表'
      },
      table: {
        id: '编号',
        name: '名称',
        preDegrees: '上期度数',
        curDegrees: '本期度数',
        degrees: '度数',
        preReadingTime: '上期读表时间',
        curReadingTime: '本期读表时间',
        reader: '抄表人',
        status: '状态',
        remark: '说明',
        auditor: '审核人',
        auditOpinion: '审核意见',
        shareProgress: '公摊进度',
        readingTime: '抄表时间',
        shareFee: '公摊费用',
        operation: '操作'
      },
      status: {
        waiting: '待审核',
        passed: '审核通过',
        rejected: '审核不通过',
        all: '全部'
      },
      add: {
        title: '公摊抄表',
        meter: '公摊表',
        selectMeter: '请选择公摊表',
        preDegrees: '上期度数',
        inputPreDegrees: '请填写上期度数',
        curDegrees: '本期度数',
        inputCurDegrees: '请填写本期度数',
        preReadingTime: '上期读表时间',
        selectPreTime: '请选择上期读表时间',
        curReadingTime: '本期读表时间',
        selectCurTime: '请选择本期读表时间',
        remark: '备注',
        inputRemark: '请填写备注(选填)'
      },
      audit: {
        title: '公摊审核',
        status: '审核',
        selectStatus: '请选择审核',
        remark: '说明',
        inputRemark: '请填写说明'
      },
      delete: {
        title: '删除确认',
        confirm: '确定删除公摊抄表?'
      },
      validate: {
        selectMeter: '请选择公摊表',
        inputPreDegrees: '请填写上期度数',
        inputCurDegrees: '请填写本期度数',
        selectPreTime: '请选择上期读表时间',
        selectCurTime: '请选择本期读表时间',
        selectStatus: '请选择审核状态',
        number: '请输入有效数字'
      },
      message: {
        addSuccess: '添加公摊抄表成功',
        auditSuccess: '审核公摊抄表成功',
        deleteSuccess: '删除公摊抄表成功'
      },
      page: {
        subtitle: '登记与审核公摊表抄表记录，并将公摊费用分摊至相关房屋',
        empty: '暂无公摊抄表记录',
        loadFailed: '公摊抄表记录加载失败，请重试'
      }
    }
  }
}